<template>
    <article :class="['rounded border border-slate-700/40 overflow-hidden relative group flex flex-col h-full', {'opacity-50': show.status == 'cancelled'}]" itemscope itemtype="https://schema.org/ComedyEvent">
        <!-- Image with overlay content -->
        <div v-if="show.image" class="relative overflow-hidden bg-slate-800 aspect-video flex flex-col justify-end flex-grow">
            <img class="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" :src="`/show-image/${show.image.replace('.','/')}/300`" :alt="show.show" fetchpriority="high" />

            <!-- Gradient overlay -->
            <div class="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent"></div>

            <!-- Date pill - top left -->
            <div class="absolute top-2 left-2 z-20">
                <span class="inline-block bg-black/70 backdrop-blur-sm px-3 py-1 rounded-full text-slate-300  text-base text-shadow uppercase tracking-wide" itemprop="startDate" :content="formatDate(show.date)">
                    {{ formatDate(show.date, 'MMMM D, YYYY') }} &mdash; {{ show.time }}
                </span>
            </div>

            <!-- Status overlay -->
            <div v-if="show.status=='cancelled' || show.status=='woodout'" class="absolute inset-0 bg-black/60 flex items-center justify-center">
                <span class="text-2xl font-bold text-white text-center">
                    {{ show.status === 'cancelled' ? 'Cancelled' : 'Can\'t Make It' }}
                </span>
            </div>

            <!-- Content overlay -->
            <div class="relative z-10 p-3 flex flex-col">

                <!-- Title -->
                <h2 class="text-shadow text-2xl font-semibold text-white leading-tight mb-0 pb-0" itemprop="name">{{ show.show }}</h2>
                <div v-if="show.venue_url" class="text-shadow text-lg text-slate-300" itemprop="location" itemscope itemtype="https://schema.org/Place">
                    <a :href="show.venue_url" class="text-yellow-300 hover:underline" itemprop="url"><span itemprop="name">{{ show.venue }}</span></a>
                    <span v-if="show.location" class="text-slate-400"> · {{ address(show.location, 0) }}</span>
                </div>
            </div>
        </div>

        <!-- Fallback for no image -->
        <div v-else class="bg-gradient-to-br from-slate-800 to-slate-900 p-4 flex flex-col gap-3 flex-grow">
            <!-- Date & Time -->
            <div class="text-xs text-slate-400 font-mono">
                {{ formatDate(show.date, 'ddd MMM DD') }} · {{ show.time }}
            </div>

            <!-- Title -->
            <h2 class="text-lg font-semibold text-secondary-light leading-tight" itemprop="name">{{ show.show }}</h2>

            <!-- Venue -->
            <div v-if="show.venue_url" class="text-xs text-slate-300 mt-auto" itemprop="location" itemscope itemtype="https://schema.org/Place">
                <a :href="show.venue_url" class="text-secondary-light hover:underline" itemprop="url"><span itemprop="name">{{ show.venue }}</span></a>
            </div>
        </div>

        <!-- Footer button (outside image) -->
        <div class="p-2 border-t border-slate-700/40 bg-slate-900/50">
            <a v-if="show.show_url && show.description.indexOf('Private') === -1" :href="show.show_url" class="block">
                <button class="w-full py-2 px-3 rounded bg-yellow-600/20 hover:bg-yellow-600/30 border border-yellow-600/50 text-yellow-200 text-xs font-medium transition uppercase">
                    {{ printLinkButton(show) }}
                </button>
            </a>
        </div>
    </article>
</template>

<script>
import dayjs from 'dayjs'
export default {
    name: "ShowObject",
    props: ['show'],
    computed: {},
    data() {
       return {

       }
    },
    mounted() {

    },
    methods: {
        address(location, half=0) {

            return location.split(', ')[half];
        },
        formatDate(a, b) {
            const date=dayjs(a);
            return date.format(b);
        },
        formatISO(d) {
            return DFunk.formatISO(DFunk.parseISO(d));
        },
        printLinkButton(show) {
            if(show.status == 'cancelled') {
                return 'Cancelled';
            }
            let s=show.show_url;
            switch (true) {
                case s.indexOf("twitch") > -1:
                case s.indexOf("zoom") > -1:
                case s.indexOf("facebook") > -1:
                    return 'Link';
                case s.indexOf('twitch') > -1:
                    return 'Twitch link';
                case s.indexOf("vermontcomedyclub") > -1:
                case s.indexOf("mpa-hub") > -1:
                    return "Tickets";
                case s.indexOf('highlight') > -1:
                    return 'Highlight Tickets'
            }

            return
        },
        performerList(performers) {
                const performerArray = [];
                performers.forEach(p => {
                    performerArray.push(`${p.firstname} ${p.lastname}`);
                })
                return new Intl.ListFormat().format(performerArray);
        },
        printDescription(d) {
            if(this.$page.url == '/') {
                return d.substring(0,120) + "... ";
            }
            return d;
        }
    }
}
</script>
